module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_unknown-ea2d31bbbea02a0cd5e519c5e5f3da4c.png";